export const setUser = (state) => {
    if (!window.User) {
        return (state.user = null)
    }

    // TODO rework use models
    window.User.isCoach = window.User.role === 'coach'
    window.User.isDoctor = window.User.role === 'doctor'
    window.User.isPatient = window.User.role === 'patient'

    // TODO rework rename global variable to vitadio
    state.user = window.User
}
